import React, { useEffect } from 'react';
import { Route, Switch, useLocation, useRouteMatch, useHistory } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { trackPageLoad } from '@fff-web/fff-analytics';

import AccountDetailsPage from '../AccountDetails/AccountDetailsPage';
import InvoiceHistory from '../InvoiceHistory/InvoiceHistory';
import PersonalSurvey from '../PersonalSurvey/PersonalSurvey';
import Orders from '../Orders';
import RateAndReview from '../RateAndReview/RateAndReview';

const MyAccountRouter = ({
  firstName,
  lastName,
  shippingAddress,
  phone,
  email,
  credits,
  billingInfo,
  setBillingInfo,
  nextRenewal,
  isDesktop,
  isClubMember,
}) => {
  const { pathname } = useLocation();
  const { path } = useRouteMatch();
  const { myAccountOrderHistory: myAccountOrderHistoryFF, rateAndReview: rateAndReviewFF } =
    useFlags();
  const history = useHistory();

  // redirect user to /my-account/invoice-history if myAccountOrderHistory FF is OFF and access /my-account/orders
  useEffect(() => {
    const isOrdersPath = pathname.includes('orders');
    if (isOrdersPath && !myAccountOrderHistoryFF) {
      history.push('/my-account/invoice-history');
    }
  }, [myAccountOrderHistoryFF]);

  useEffect(() => {
    trackPageLoad({ pathName: pathname });
  }, [pathname]);

  return (
    <Switch>
      <Route exact path={path}>
        <AccountDetailsPage
          firstName={firstName}
          lastName={lastName}
          phone={phone}
          email={email}
          shippingAddress={shippingAddress}
          credits={credits}
          billingInfo={billingInfo}
          setBillingInfo={setBillingInfo}
          nextRenewal={nextRenewal}
          isClubMember={isClubMember}
        />
      </Route>
      <Route exact path={`${path}/orders`}>
        <Orders isDesktop={isDesktop} />
      </Route>
      {rateAndReviewFF && (
        <Route exact path={`${path}/rate-and-review`}>
          <RateAndReview />
        </Route>
      )}
      <Route exact path={`${path}/invoice-history`}>
        <InvoiceHistory />
      </Route>
      <Route exact path={`${path}/personal-survey`}>
        <PersonalSurvey />
      </Route>
    </Switch>
  );
};

export default MyAccountRouter;
